const styles = theme => ({
  buttonContainer: {
    padding: '20px 16px',
  },
  button: {
    height: '36px',
    minWidth: '167px',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'none',
    border: '1.36111px solid #342D3D',
    borderRadius: '10px',
    '& img': {
      marginRight: '4px',
      width: '12px',
    },
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  listItem: {
    display: 'flex',
    width: '100%',
    padding: '20px 16px 12px 16px',
    borderBottom: '1px solid #EBEEF3',

    '& img': {
      width: '50px',
      height: '55px',
      marginRight: '6px',
    },

    '& $details': {
      '& p': {
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '24px',
        color: theme.palette.primary.dim,

        '&:first-child': {
          fontSize: '14px',
          fontWeight: 600,
          lineHeight: '27px',
          color: theme.palette.primary.adgmBlack,
        },
      },
    },

    '& > div:last-child': {
      marginLeft: 'auto',
      minWidth: '66px',
      '& button': {
        fontSize: '12px',
        color: theme.palette.primary.darkGrey,
        fontWeight: 500,
        textTransform: 'none',
      },
    },
  },
  details: {},

  '@media (min-width: 768px)': {
    buttonContainer: {
      padding: '30px 24px',
    },
    button: {
      height: '60px',
      minWidth: '228px',
      fontSize: '16px',
      borderRadius: '13.6111px',
      '& img': {
        marginRight: '8px',
        width: '17px',
      },
    },
    listItem: {
      padding: '30px 24px 16px 24px',
      '& img': {
        width: '60px',
        height: '65px',
      },
      '& $details': {
        '& p': {
          fontSize: '16px',
          lineHeight: '24px',

          '&:first-child': {
            fontSize: '18px',
            lineHeight: '27px',
          },
        },
      },
      '& > div:last-child': {
        '& button': {
          fontSize: '14px',
          color: theme.palette.primary.darkGrey,
          fontWeight: 500,
          textTransform: 'none',
        },
      },
    },
  },
});

export default styles;
